import React from 'react'
import PropTypes from 'prop-types'
import Form from '../../../../../common/formComponents/Form'
import FormElement from '../../../../../common/formComponents/FormElement'
import moment from 'moment'

const RecommendationEditForm = ({recommendation, translate, handleSubmit}) => {
  const { doseNumber, dateCriterion } = recommendation
  return <Form handleSubmit={handleSubmit}>
    <FormElement
      type={'number'}
      defaultValue={doseNumber}
      label={translate('doseNumber')}
      name={'doseNumber'} />
    <FormElement
      type={'date'}
      defaultValue={moment(new Date(dateCriterion.earliest)).format('YYYY-MM-DD')}
      label={translate('earliest')}
      name={'earliest'} />
    <FormElement
      type={'date'}
      defaultValue={moment(new Date(dateCriterion.recommended)).format('YYYY-MM-DD')}
      label={translate('recommended')}
      name={'recommended'} />
    <FormElement
      type={'date'}
      defaultValue={moment(new Date(dateCriterion.latest)).format('YYYY-MM-DD')}
      label={translate('latest')}
      name={'latest'} />
    <button className='uk-button uk-button-primary uk-align-right' type='submit'>{translate('submit')}</button>
  </Form>
}

RecommendationEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  recommendation: PropTypes.object.isRequired
}

export default RecommendationEditForm
